<template>
  <div v-if="User" class="user-badge"  ref="userBadge" @click="showUserMenu">
    <div class="user-image">
      <v-img src="@/assets/user.png" class="company-logo"/>
    </div>
    <div ref="userMenu" class="user-menu" v-if="showUserInfo">
      <div class="user-initials">
        {{ User.initials }}
      </div>
      <div class="user-company">
        {{ User.data.orgname }}
      </div>
      <div class="user-logout" @click="logout">
        <div class="logout-text">
          LOGOUT
        </div>
        <img class="logout-icon" :src="require('@/assets/svg/SVG/logout.svg')" alt="Logout">
      </div>
    </div>
  </div>
</template>

<script>
import {mapStores} from 'pinia';
import {useIdentityStore} from '@/store/IdentityStore';
import {gsap} from 'gsap';

export default {
  data () {
    return {
      showUserInfo: false
    };
  },
  setup () {
    const indentityStore = useIdentityStore();
    return{
      indentityStore
    };
  },
  computed: {
    ...mapStores(useIdentityStore),
    User () {
      if (this.identityStore.User) {
        return this.identityStore.User;
      } else {
        return null;
      }
    }
  },
  mounted () {
    if (this.$refs.userMenu === undefined) {
      return;
    }
    gsap.set(this.$refs.userMenu, {
      display: 'none',
      alpha: 0
    });

  },
  methods: {
    logout (e) {
      e.stopImmediatePropagation();
      this.identityStore.signout();
    },
    showUserMenu (e) {
       this.showUserInfo = !this.showUserInfo;
       if (this.showUserInfo) {
         document.body.addEventListener('click', this.handleBodyClick);
         e.stopImmediatePropagation();
       } else {
         this.handleBodyClick(e);
       }
    },
    hideUserMenu () {
      this.showUserInfo = false;
    },
    handleBodyClick (e) {
      this.hideUserMenu();
      document.body.removeEventListener('click', this.handleBodyClick);
      e.stopImmediatePropagation();
    }
  }
};


</script>

<style scoped>
.company-logo {
  width: calc(100%);
  height: auto;

}

.user-badge {

  position: fixed;
  bottom: 25px;
  left: 12px;
  height: 70px;
  padding-right: 10px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 200000;

}

.user-image {
  width: 35px;
  height: 35px;
  background-color: #96b2ce;
  border-radius: 25px;
  align-items: center;
}

.user-menu {
/*  pointer-events: none;*/
  margin-left: 10px;
}

.user-initials {
  pointer-events: none;
  font-weight: bold;
  font-size: .85em;
}

.user-company {
  pointer-events: none;
  font-size: .87em;
}

.user-logout {
  margin-top: 3px;
  font-size: .8em;
  font-weight: bold;
  letter-spacing: .02em;
  display: flex;
  align-items: center;

}

.logout-icon {
  margin-left: 7px;
  height: 15px;
}

.logout-text {
  margin-top: 1px;
}
</style>